import { render, staticRenderFns } from "./SendTab.vue?vue&type=template&id=8b8e313e&"
import script from "./SendTab.vue?vue&type=script&lang=js&"
export * from "./SendTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports